import { deliveryStatusStyle } from '@bingads-webui-campaign-react/common-styles';

export const getDeliveryStatusStyle = (_, { palette = {} }) => ({
  '@global': {
    ...deliveryStatusStyle({ palette }),
  },

  statusContainer: {
    '& .underline': {
      borderBottomColor: palette.themePrimary,
      borderBottomStyle: 'dashed',
      borderBottomWidth: 1,

      '& .status-icon': {
        marginRight: 5,
      },

      '& .iconba-ErrorBadge, .status-error': {
        color: '#A80000',
      },

      '& .iconba-Warning, .status-warning': {
        color: '#D83B01',
      },
    },
  },
});
